import api from '../api';

class PublicCpfAccessData {
  show(companyKey) {
    return api.get(`/public-cpf-access/${companyKey}`);
  }

  auth(companyKey, cpf, domain) {
    return api.post(`/public-cpf-access/${companyKey}/auth`, { cpf, domain });
  }
}

export default new PublicCpfAccessData();
